import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  table: {
    // minWidth: 500,
  },
  tableHead: {
    backgroundColor: '#00ae9c',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  tableCell: {
    fontSize: 16,
  },
}))
 function somar(horas) {
   let total = 0;
   horas.map(soma => (
     total = total + soma
   ))
   return total
 }

function CourseTable({ subjects, hours }) {
  const classes = useStyles()
 
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="tabela de grade curricular">
        <TableHead>
          <TableRow component="th" scope="row">
            <TableCell className={classes.tableHead}>Disciplina</TableCell>
            <TableCell className={classes.tableHead}>Carga Horária</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {subjects.map((row, index) => (
            <>
              <TableRow>
                <TableCell className={classes.tableCell}>{hours[index] == null ? <strong> {row}  </strong> : row}</TableCell>
                <TableCell className={classes.tableCell}>
                  {hours[index] != null ? hours[index] + 'H' : ''}
                </TableCell>
              </TableRow>
            </>
          ))}
        </TableBody>
        <TableHead>
          <TableRow component="th" scope="row">
            <TableCell className={classes.tableHead}>Total: </TableCell>
            <TableCell className={classes.tableHead}>
              {hours.reduce((h, value) => h + value)}H
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>
    </TableContainer>
  )
}

export default CourseTable
